import { ROLES } from '@/common/constants';
import * as Yup from 'yup';

export const companyProfileSchema = (role: string) => Yup.object({
    type: (role === ROLES.INSPECTING_COMPANY) ?
        Yup.array()
            .of(Yup.string().oneOf(['SIRE | BIRE', 'Vetting'], 'Invalid selection for type'))
            .min(1, 'At least one type is required')
        :
        Yup.array()
            .of(Yup.string().oneOf(['SIRE | BIRE', 'Vetting'], 'Invalid selection for type'))
});
